import React from 'react';
import { Form, Formik } from 'formik';
import {
  Button,
  Card,
  Container,
  Grid
} from '@material-ui/core';
import Header from './Header';
import MyRadioButton from './MyRadioButton';

function FirstResponder({ formData, setFormData, nextPage, prevPage }) {
  return (
    <React.Fragment>
      <Header title="Are you military or a first responder?" />
      <Container maxWidth="md" style={{ height: '500px', padding: '1rem' }}>
        <Card raised>
          <Formik
            initialValues={formData}
            onSubmit={(values, actions) => {
              // console.log(JSON.parse(JSON.stringify(values)));
              setFormData(values);
              nextPage();
            }}
          >
            {formik => (
              <Form>
                <Container maxWidth="sm" style={{ padding: '1rem' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <MyRadioButton name="firstResponder" type="radio" value="true" label="Yes" />
                    </Grid>
                    <Grid item xs={12}>
                      <MyRadioButton name="firstResponder" type="radio" value="false" label="No" />
                    </Grid>
                    <Grid item xs={4}>
                      <Button variant="contained" onClick={prevPage} fullWidth>Back</Button>
                    </Grid>
                    <Grid item xs={8}>
                      <Button variant="contained" color="primary" type="submit" fullWidth>Next</Button>
                    </Grid>
                  </Grid>
                </Container>
                {/* <pre>{JSON.stringify(formik.values, null, 2)}</pre> */}
              </Form>
            )}
          </Formik>
        </Card>
      </Container>
    </React.Fragment>
  );
}

export default FirstResponder;